module.exports = __webpack_public_path__ + "assets/img/faq-hero.6a568da2.webp";